module.exports = __webpack_public_path__ + "06e22c6945df97df2a5dede700079a6d.pdf";